// class imagegalleryslider extends HTMLElement {
//   constructor() {
//     super();
//   }
//   connectedCallback() {
//     const handleIntersection = (entries, observer) => {
//       if (!entries[0].isIntersecting) return;
//       observer.unobserve(this);
//         var autoplay = $(this).data('autoplay');
//       console.log("autoplay");
//         var swiper = new Swiper(
//           ".image-gallery--" + this.getAttribute("data-sectionid"),
//           {
//             slidesPerView: "auto",
//             observer: true,
//             observeParents: true,
//             spaceBetween: 20,

//               autoplay: {
//                 enabled = autoplay,
//                 delay: 2500,
//                 disableOnInteraction: false,
//               },
//             pagination: {
//               el: ".swiper-pagination",
//             },
//             breakpoints: {
//               769: {
//                 slidesPerView: "auto",
//                 spaceBetween: 30,
//               }
//             },
//           }
//         );

//     };
//     new IntersectionObserver(handleIntersection.bind(this), {
//       rootMargin: "0px 0px 400px 0px",
//     }).observe(this);
//   }
// }
// customElements.define("image-gallery-slider", imagegalleryslider);

class FaqSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".faq-questions-" + this.getAttribute("data-sectionid")).click(
        function (e) {
          e.preventDefault();
          let $this = $(this);
          if ($this.next().hasClass("show")) {
            $this.next().removeClass("show");
            $this.next().slideUp(350);
            $this.parent().removeClass("active");
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "flex" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "none" });
          } else {
            // $(".faq-accordion-wrapper")
            //   .find(".faq-answers")
            //   .removeClass("show");
            // $(".faq-accordion-wrapper").find(".faq-answers").slideUp(350);
            // $(".faq-accordion-wrapper").removeClass("active");
            // $(".faq-accordion-wrapper")
            //   .find(".fa-chevron-arrows")
            //   .find(".fa-chevron-down")
            //   .css({ display: "flex" });
            // $(".faq-accordion-wrapper")
            //   .find(".fa-chevron-arrows")
            //   .find(".fa-chevron-up")
            //   .css({ display: "none" });
            $this.next().toggleClass("show");
            $this.next().slideToggle(350);
            $this.parent().toggleClass("active");
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-down")
              .css({ display: "none" });
            $this
              .find(".fa-chevron-arrows")
              .find(".fa-chevron-up")
              .css({ display: "flex" });
          }
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("faq-section", FaqSection);
